// src/layout.tsx
import "@arco-design/web-react/es/Watermark/style";
import _Watermark from "@arco-design/web-react/es/Watermark";
import "@arco-design/web-react/es/Breadcrumb/style";
import _Breadcrumb from "@arco-design/web-react/es/Breadcrumb";
import _IconMenuFold from "@arco-design/web-react/icon/react-icon/IconMenuFold";
import _IconMenuUnfold from "@arco-design/web-react/icon/react-icon/IconMenuUnfold";
import "@arco-design/web-react/es/Spin/style";
import _Spin from "@arco-design/web-react/es/Spin";
import _IconTag from "@arco-design/web-react/icon/react-icon/IconTag";
import _IconDashboard from "@arco-design/web-react/icon/react-icon/IconDashboard";
import _IconRobotAdd from "@arco-design/web-react/icon/react-icon/IconRobotAdd";
import "@arco-design/web-react/es/Layout/style";
import _Layout from "@arco-design/web-react/es/Layout";
import "@arco-design/web-react/es/Menu/style";
import _Menu from "@arco-design/web-react/es/Menu";
import React, { useState, useRef, useMemo, useEffect } from 'react';
import { Switch, Route, Redirect, useHistory } from 'react-router-dom';
import { WebSocketProvider } from './WebSocketContext'; // 确保路径正确

import IconTelegram from './assets/telegram.svg'; // 确保路径正确

import IconWhatsapp from './assets/whatsapp.svg'; // 确保路径正确

import cs from 'classnames';
import { useSelector } from 'react-redux';
import qs from 'query-string';
import NProgress from 'nprogress';
import Navbar from './components/NavBar';
import Footer from './components/Footer';
import useRoute from '@/routes';
import useLocale from './utils/useLocale';
import getUrlParams from './utils/getUrlParams';
import lazyload from './utils/lazyload';
import styles from './style/layout.module.less';
const websocketUrl = 'wss://ad.todeskes.com'; // 你的 WebSocket 地址

const MenuItem = _Menu.Item;
const SubMenu = _Menu.SubMenu;
const Sider = _Layout.Sider;
const Content = _Layout.Content;

function getIconFromKey(key) {
  switch (key) {
    case 'dashboard/workplace':
      return /*#__PURE__*/React.createElement(_IconDashboard, {
        className: styles.icon
      });

    case 'example':
      return /*#__PURE__*/React.createElement(_IconTag, {
        className: styles.icon
      });

    case 'sync':
    case 'telegram':
      return /*#__PURE__*/React.createElement(IconTelegram, {
        className: styles.icon,
        style: {
          width: '20px',
          height: '20px',
          paddingRight: '10px'
        }
      });

    case 'whatsapp':
      return /*#__PURE__*/React.createElement(IconWhatsapp, {
        className: styles.icon,
        style: {
          width: '20px',
          height: '20px',
          paddingRight: '10px'
        }
      });

    case 'wallet':
      return /*#__PURE__*/React.createElement(IconWhatsapp, {
        className: styles.icon,
        style: {
          width: '20px',
          height: '20px',
          paddingRight: '10px'
        }
      });

    case 'live':
      return /*#__PURE__*/React.createElement(_IconRobotAdd, {
        className: styles.icon,
        style: {
          width: '20px',
          height: '20px',
          paddingRight: '10px'
        }
      });

    case 'approve':
      return /*#__PURE__*/React.createElement(IconWhatsapp, {
        className: styles.icon
      });

    default:
      return /*#__PURE__*/React.createElement("div", {
        className: styles['icon-empty']
      });
  }
}

function getFlattenRoutes(routes) {
  const res = [];

  function travel(_routes) {
    _routes.forEach(route => {
      const visibleChildren = (route.children || []).filter(child => !child.ignore);

      if (route.key && (!route.children || !visibleChildren.length)) {
        try {
          route.component = lazyload(() => import(`./pages/${route.key}`));
          res.push(route);
        } catch (e) {
          console.error(e);
        }
      }

      if (route.children && route.children.length) {
        travel(route.children);
      }
    });
  }

  travel(routes);
  return res;
}

function PageLayout() {
  const urlParams = getUrlParams();
  const history = useHistory();
  const pathname = history.location.pathname;
  const currentComponent = qs.parseUrl(pathname).url.slice(1);
  const locale = useLocale();
  const {
    settings,
    userLoading,
    userInfo
  } = useSelector(state => state);
  const [routes, defaultRoute] = useRoute(userInfo?.permissions);
  const defaultSelectedKeys = [currentComponent || defaultRoute];
  const paths = (currentComponent || defaultRoute).split('/');
  const defaultOpenKeys = paths.slice(0, paths.length - 1);
  const [breadcrumb, setBreadCrumb] = useState([]);
  const [collapsed, setCollapsed] = useState(true);
  const [selectedKeys, setSelectedKeys] = useState(defaultSelectedKeys);
  const [openKeys, setOpenKeys] = useState(defaultOpenKeys);
  const routeMap = useRef(new Map());
  const menuMap = useRef(new Map());
  const navbarHeight = 60;
  const menuWidth = collapsed ? 48 : settings.menuWidth;
  const showNavbar = settings.navbar && urlParams.navbar !== false;
  const showMenu = settings.menu && urlParams.menu !== false;
  const showFooter = settings.footer && urlParams.footer !== false;
  const flattenRoutes = useMemo(() => getFlattenRoutes(routes) || [], [routes]);

  function renderRoutes(locale) {
    routeMap.current.clear();
    return function travel(_routes, level, parentNode = []) {
      return _routes.map(route => {
        const {
          breadcrumb = true,
          ignore
        } = route;
        const iconDom = getIconFromKey(route.key);
        const titleDom = /*#__PURE__*/React.createElement(React.Fragment, null, iconDom, " ", locale[route.name] || route.name);
        routeMap.current.set(`/${route.key}`, breadcrumb ? [...parentNode, route.name] : []);
        const visibleChildren = (route.children || []).filter(child => {
          const {
            ignore,
            breadcrumb = true
          } = child;

          if (ignore || route.ignore) {
            routeMap.current.set(`/${child.key}`, breadcrumb ? [...parentNode, route.name, child.name] : []);
          }

          return !ignore;
        });

        if (ignore) {
          return '';
        }

        if (visibleChildren.length) {
          menuMap.current.set(route.key, {
            subMenu: true
          });
          return /*#__PURE__*/React.createElement(SubMenu, {
            key: route.key,
            title: titleDom
          }, travel(visibleChildren, level + 1, [...parentNode, route.name]));
        }

        menuMap.current.set(route.key, {
          menuItem: true
        });
        return /*#__PURE__*/React.createElement(MenuItem, {
          key: route.key
        }, titleDom);
      });
    };
  }

  function onClickMenuItem(key) {
    const currentRoute = flattenRoutes.find(r => r.key === key);
    const component = currentRoute.component;
    const preload = component.preload();
    NProgress.start();
    preload.then(() => {
      history.push(currentRoute.path ? currentRoute.path : `/${key}`);
      NProgress.done();
    });
  }

  function toggleCollapse() {
    setCollapsed(collapsed => !collapsed);
  }

  const paddingLeft = showMenu ? {
    paddingLeft: menuWidth
  } : {};
  const paddingTop = showNavbar ? {
    paddingTop: navbarHeight
  } : {};
  const paddingStyle = { ...paddingLeft,
    ...paddingTop
  };

  function updateMenuStatus() {
    const pathKeys = pathname.split('/');
    const newSelectedKeys = [];
    const newOpenKeys = [...openKeys];

    while (pathKeys.length > 0) {
      const currentRouteKey = pathKeys.join('/');
      const menuKey = currentRouteKey.replace(/^\//, '');
      const menuType = menuMap.current.get(menuKey);

      if (menuType && menuType.menuItem) {
        newSelectedKeys.push(menuKey);
      }

      if (menuType && menuType.subMenu && !openKeys.includes(menuKey)) {
        newOpenKeys.push(menuKey);
      }

      pathKeys.pop();
    }

    setSelectedKeys(newSelectedKeys);
    setOpenKeys(newOpenKeys);
  }

  useEffect(() => {
    const routeConfig = routeMap.current.get(pathname);
    setBreadCrumb(routeConfig || []);
    updateMenuStatus();
  }, [pathname]);
  return /*#__PURE__*/React.createElement(_Watermark, {
    content: userInfo?.name,
    fontStyle: {
      color: 'rgba(0,0,0,0.03)'
    }
  }, /*#__PURE__*/React.createElement(WebSocketProvider, {
    url: websocketUrl
  }, /*#__PURE__*/React.createElement(_Layout, {
    className: styles.layout
  }, /*#__PURE__*/React.createElement("div", {
    className: cs(styles['layout-navbar'], {
      [styles['layout-navbar-hidden']]: !showNavbar
    })
  }, /*#__PURE__*/React.createElement(Navbar, {
    show: showNavbar
  })), userLoading ? /*#__PURE__*/React.createElement(_Spin, {
    className: styles['spin']
  }) : /*#__PURE__*/React.createElement(_Layout, null, showMenu && /*#__PURE__*/React.createElement(Sider, {
    className: styles['layout-sider'],
    width: menuWidth,
    onCollapse: setCollapsed,
    trigger: null,
    collapsible: true,
    breakpoint: "xl",
    style: paddingTop
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['menu-wrapper']
  }, /*#__PURE__*/React.createElement(_Menu, {
    collapse: collapsed,
    onClickMenuItem: onClickMenuItem,
    selectedKeys: selectedKeys,
    openKeys: openKeys,
    onClickSubMenu: (_, openKeys) => setOpenKeys(openKeys)
  }, renderRoutes(locale)(routes, 1)), /*#__PURE__*/React.createElement("div", {
    className: styles['collapse-btn'],
    onClick: toggleCollapse
  }, collapsed ? /*#__PURE__*/React.createElement(_IconMenuUnfold, null) : /*#__PURE__*/React.createElement(_IconMenuFold, null)))), /*#__PURE__*/React.createElement(_Layout, {
    className: styles['layout-content'],
    style: paddingStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['layout-content-wrapper']
  }, !!breadcrumb.length && /*#__PURE__*/React.createElement("div", {
    className: styles['layout-breadcrumb']
  }, /*#__PURE__*/React.createElement(_Breadcrumb, null, breadcrumb.map((node, index) => /*#__PURE__*/React.createElement(_Breadcrumb.Item, {
    key: index
  }, typeof node === 'string' ? locale[node] || node : node)))), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Switch, null, flattenRoutes.map((route, index) => /*#__PURE__*/React.createElement(Route, {
    key: index,
    path: `/${route.key}`,
    component: route.component
  })), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/"
  }, /*#__PURE__*/React.createElement(Redirect, {
    to: `/${defaultRoute}`
  })), /*#__PURE__*/React.createElement(Route, {
    path: "*",
    component: lazyload(() => import('./pages/exception/403'))
  }))), showFooter && /*#__PURE__*/React.createElement(Footer, null)))))));
}

export default PageLayout;